import type React from 'react'
import type { ReactNode } from 'react'

import { URL_CONST } from 'constants/urls'

import { ExternalLinkStyled, RouterLinkStyled } from './styles'

export interface TextButtonProps {
  external?: boolean
  url?: string
  target?: '_blank' | '_self'
  children?: ReactNode
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

export const TextButton = ({
  external,
  url,
  target = '_blank',
  children,
  disabled = false,
  onClick,
}: TextButtonProps) => {
  if (external) {
    return (
      <ExternalLinkStyled
        data-testid="external_button"
        onClick={onClick}
        target={target}
        {...(url && { href: url })}
        disabled={disabled}
      >
        {children}
      </ExternalLinkStyled>
    )
  }

  return (
    <RouterLinkStyled
      data-testid="internal_button"
      disabled={disabled}
      onClick={onClick}
      to={url || URL_CONST.ROOT}
    >
      {children}
    </RouterLinkStyled>
  )
}
